import React, { createContext, useState } from 'react';
interface RoomContextProviderProps {
  children: React.ReactNode;
}

// eslint-disable-next-line
export const RoomContext = createContext();

export const RoomContextProvider = ({ children }: RoomContextProviderProps) => {
  const [startedButNotSubmitted, setStartedButNotSubmitted] = useState(0);

  return (
    <RoomContext.Provider value={{ startedButNotSubmitted, setStartedButNotSubmitted }}>
      {children}
    </RoomContext.Provider>
  );
};
